import { useMutation } from 'react-query';
import api, { refreshAccessToken } from 'src/services/api';

// Deletes the refresh token server-side, expires the cookie, and invalidates access tokens.
export const logout = async () => api.post('/auth/logout');

// Trades the refresh cookie for a new access token and a rotated refresh cookie.
export const refreshSession = async () => refreshAccessToken();

export const useLogout = () => useMutation(logout);
